import {
  EEntityType,
  IFavoriteEntityForDesktopSchema,
} from '../../../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { IFavorite } from '../../../../types/favorites';

export function prepareFavorites(data: IFavoriteEntityForDesktopSchema[]): IFavorite[] {
  return data.map(favorite => {
    return {
      entityId: favorite.entityId,
      title: favorite.title,
      geo: favorite.geo,
      photoFullUrl: favorite.photoFullUrl ?? null,
      price: favorite.bargainTerms.priceText ?? null,
      entityType: favorite.entityType === EEntityType.Newbuilding ? 'newbuilding' : 'ads',
      fullUrl: favorite.fullUrl,
    };
  });
}
